import colors from '../colors.js';
colors("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");
//# sourceMappingURL=Tableau10.js.map
